import { FAQPage, FAQOrderBy, VideoCategory, VideoOrderBy } from './successlauncher-types';

/**
 * Generates a faq page graphql query for GraphCMS.
 * @param page The page to query for.
 * @param orderBy The position order.  Default: `position`.
 */
export function faqQuery(page: FAQPage, orderBy: FAQOrderBy = 'Position') {
  // format of a json graphql payload
  return {
    query: `query FAQs { SL_FAQ(sort: "${orderBy}", filter: {status: {_eq: "published"}, Page: {_eq: "${page}"}}) { Page Position Question Answer Link Environment } }`
  };
}

export function videoQuery(category: VideoCategory, orderBy: VideoOrderBy = 'Position') {
  // format of a json graphql payload
  return {
    query: `query Videos { SL_Video(sort: "${orderBy}", filter: {status: {_eq: "published"}, Category: {_eq: "${category}"}}) { Category Position Title Body URL Environment } }`
  };
}

/**
 * Gets the faq page associated with a url path segment.
 * @param path The path segment.
 */
export function getFaqPage(path: string): FAQPage {
  if (/^\/forms$/.test(path)) {
    return 'Forms_Tab';
  }

  if (/^\/forms\/.+/.test(path)) {
    return 'Form_Editor';
  }

  if (/^\/templates$/.test(path)) {
    return 'Templates_Tab';
  }

  if (/^\/templates\/.+/.test(path)) {
    return 'Template_Editor';
  }

  if (/^\/workflows$/.test(path)) {
    return 'Workflows_Tab';
  }

  if (/^\/workflows\/.+/.test(path)) {
    return 'Workflows_Editor';
  }

  if (/^\/reports(\/viewer)?$/.test(path)) {
    return 'Reports_Tab';
  }

  if (/^\/reports\/designer/.test(path)) {
    return 'Reports_Designer';
  }

  if (/^\/publicforms/.test(path)) {
    return 'Public_Forms';
  }

  if (/^\/datasource/.test(path)) {
    return 'DataSources';
  }

  if (/^\/applications/.test(path)) {
    return 'Connected_Apps';
  }

  if (/^\/user(s)?/.test(path)) {
    return 'Users_Groups';
  }

  if (/^\/subscription/.test(path)) {
    return 'Subscriptions';
  }

  // default to the homepage faq section if a match is not found
  return 'Homepage';
}
